
import React from 'react';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

interface BulletinErrorBoundaryProps {
  children: React.ReactNode;
}

export const BulletinErrorBoundary: React.FC<BulletinErrorBoundaryProps> = ({ children }) => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <ErrorBoundary
      fallback={
        <Alert variant="destructive" className="my-4">
          <AlertTitle>Error Loading Bulletins</AlertTitle>
          <AlertDescription className="space-y-2">
            <p>There was an error loading the bulletins. Please try again.</p>
            <Button
              variant="outline"
              size="sm"
              onClick={handleRetry}
              className="mt-2"
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              Retry
            </Button>
          </AlertDescription>
        </Alert>
      }
    >
      {children}
    </ErrorBoundary>
  );
};
